import { render } from "./PendidiknDasar.vue?vue&type=template&id=1369e446"
import script from "./PendidiknDasar.vue?vue&type=script&lang=js"
export * from "./PendidiknDasar.vue?vue&type=script&lang=js"

import "./PendidiknDasar.vue?vue&type=style&index=0&id=1369e446&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__